import React from "react";

const SignatureStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 17L15.9444 17C15.5721 17 15.2071 16.8967 14.8901 16.7016L14.7343 16.6057C14.1381 16.2388 13.3798 16.2658 12.8112 16.674V16.674C12.5159 16.886 12.1617 17 11.7982 17L10.5 17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 17L7.10752 16.0335L16.3494 6.79158C17.2169 5.92421 17.2169 4.51791 16.3494 3.65053C15.482 2.78316 14.0758 2.78316 13.2084 3.65053L3.96648 12.8925L3 17Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SignatureStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;